import React from "react";
import { List, ListSubheader, ListItem, ListItemText } from "@mui/material";
import { IOption } from "../../app/types";

/* Functional component properties */
interface Props {
  classes: any;
  header: string;
  list: IOption[];
  handler: (link: IOption) => void;
}

/* React Functional component */
export const LinkList: React.FC<Props> = ({
  /* Function arguments (Props) */
  classes,
  header,
  list,
  handler,
}): JSX.Element => {
  return (
    <List
      component="nav"
      aria-labelledby="Links"
      subheader={
        <ListSubheader component="div" id="Links">
          {header}
        </ListSubheader>
      }
    >
      {list.map((option) => (
        <ListItem
          button
          key={option.name}
          id={option.name}
          onClick={(e) => handler(option)}
        >
          <ListItemText primary={option.text} className={classes.sidebarMenu} />
        </ListItem>
      ))}
    </List>
  );
};
